import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/procurement/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/procurement/supplier-report",
    })
  },
})
